// import $ from "jquery";
import '~/jquery-ui/ui/widgets/datepicker';
import baseClass from "./base";

var DATECLASS = function () {

  this.getDatePickerOptions = function (obj) {
    const rez = {};

    rez.currentText = "Now";

    const minDate = obj.attr("data-mindate");
    if (minDate != undefined && minDate) rez.minDate = minDate;

    const maxDate = obj.attr("data-maxdate");
    if (maxDate != undefined && maxDate) rez.maxDate = maxDate;

    const changeMonth = obj.attr("data-changem");
    rez.changeMonth = changeMonth == undefined || !changeMonth ? false : true;

    const changeYear = obj.attr("data-changey");
    rez.changeYear = changeYear == undefined || !changeYear ? false : true;

    const constrainInput = obj.attr("data-constrain");
    rez.constrainInput = constrainInput == undefined || !constrainInput ? true : false;

    const showAnim = obj.attr("data-anim");
    rez.showAnim = (showAnim != undefined && showAnim) ? maxDate : 'slideDown';

    const defaultDate = obj.attr("data-defaultdate");
    rez.defaultDate = (defaultDate != undefined && defaultDate) ? defaultDate : 0;

    // ---
    const dateFormat = obj.attr("data-format");
    if (dateFormat != undefined && dateFormat) {
      rez.dateFormat = dateFormat;
    } else
    {
      var tobj = $("#datelabelinfo");
      if (tobj != undefined)
      {
        var a = tobj.attr("data-dateformat");
        if (a != undefined && a)
        {
          rez.dateFormat = a;
        }
      }
    }
    // ---

    // ---
    const firstDay = obj.attr("data-firstday");
    if (firstDay != undefined && firstDay) {
      rez.firstDay = firstDay;
    } else
    {
      var tobj = $("#datelabelinfo");
      if (tobj != undefined)
      {
        var a = tobj.attr("data-firstday");
        if (a != undefined && a)
        {
          rez.firstDay = a;
        }
      }
    }
    // ---

    // ---
    var tobj = $("#datelabelinfo");
    if (tobj != undefined)
    {
      const monthNames = tobj.attr("data-monthslong");
      const monthNamesShort = tobj.attr("data-monthsshort");
      const dayNames = tobj.attr("data-daynames");
      const dayNamesShort = tobj.attr("data-daynamesshort");
      const dayNamesMin = tobj.attr("data-daynamesmin");

      if (monthNames != undefined && monthNames) rez.monthNames = monthNames.split("|");
      if (monthNamesShort != undefined && monthNamesShort) rez.monthNamesShort = monthNamesShort.split("|");
      if (dayNames != undefined && dayNames) rez.dayNames = dayNames.split("|");
      if (dayNamesShort != undefined && dayNamesShort) rez.dayNamesShort = dayNamesShort.split("|");
      if (dayNamesMin != undefined && dayNamesMin) rez.dayNamesMin = dayNamesMin.split("|");
    }

    // ---
    
    
    // --------------------
    const onselecttype = obj.attr("data-onselecttype");
    if (onselecttype != undefined) {
      var onselecttypes = onselecttype.split("|");
    } else {
      var onselecttypes = [];
    }
    const setinputobj = obj.attr("data-setinputobj");
    const submitformobj = obj.attr("data-submitformobj");
    const onselect = obj.attr("data-onselect");
    var tip = obj.attr("data-tip");
    var targid = obj.attr("data-targid");
    const inithref = obj.attr("data-href");
    const putloadinindicator = obj.attr("data-putloadinindicator");
    if (onselect != undefined && onselect)
    {
      rez.onSelect = function (date) {
        if (onselect == undefined || !onselect || onselect == "0") return;

        if ($.inArray("setinput", onselecttypes) != -1) {
          $(setinputobj).val(date);
        }

        if ($.inArray("url", onselecttypes) != -1) {
          if (!tip) tip = "ajax";
          if (!targid) targid = "main";
          if (!inithref) return;

          href = inithref + date;

          // --------------
          var info = {};
          
          info.href = href;
                  
          var url = href;
          url += url.indexOf("?") != -1 ? "&" : "?";
          url += "rt=ajax";

          info.url = url;
          info.targetid = targid;
          info.stopother = 0;
          info.showLoading = (putloadinindicator) ? false : true;

          if (!isNaN(parseInt(putloadinindicator)) && parseInt(putloadinindicator) ) {
            baseClass.putloadinindicator(targid);
          }
          // --------------

          if (tip == "simple") {
            window.location.href = href;
            return;
          }
          if (tip == "ajax") {
            info.type = "ajaxHTML";
            baseClass.getAjaxHTML(info);

            return;
          }
          if (tip == "ajaxHistory") {
            info.type = "ajaxHistory";
            baseClass.getAjaxHTML(info);
            
            return;
          }
        }

        if ($.inArray("submit", onselecttypes) != -1) {
          $(submitformobj).submit();
        }
      };
    }
    // --------------------

    return rez;
  }

  this.datePicker = function (obj) {
    obj.attr("autocomplete", "off");

    const options = dateClassObj.getDatePickerOptions(obj);

    obj.datepicker(options);
  };

};

var dateClassObj = new DATECLASS();

baseClass.OnReadyArrAdd(function () { 
  $(".js_date").each(function () { 
    if ($(this).hasClass("true_js_date")) return;
    $(this).addClass("true_js_date");  
    
    dateClassObj.datePicker($(this));
  });
});

export default dateClassObj;
